import React from 'react';
import { APP_LOGO_SRC } from '../constants';

// Shown, full screen, to a person whose account was banned when they try to sign in (or are signed out because of the ban).
const BannedPage: React.FC<{ onClose: () => void }> = ({ onClose }) => (
  <div
    className="ridaz-banned fixed inset-0 z-[10000] flex flex-col items-center justify-center overflow-y-auto bg-[#05060a] px-8 text-center !text-red-500"
    style={{ paddingTop: 'var(--sat-native, env(safe-area-inset-top))', paddingBottom: 'var(--sab-native, env(safe-area-inset-bottom))' }}
    role="alert"
  >
    <img src={APP_LOGO_SRC} alt="RIDAZ" className="h-24 w-24 rounded-2xl object-contain opacity-90" />
    <h1 className="mt-8 text-4xl font-black leading-tight tracking-tight !text-red-500">You have been banned</h1>
    <p className="mt-4 max-w-sm text-lg font-semibold leading-snug !text-red-500">You have been banned due to inappropriate content.</p>
    <button
      type="button"
      onClick={onClose}
      className="mt-10 rounded-xl border-2 !border-red-500 !bg-red-500/10 px-8 py-3 text-base font-extrabold !text-red-500 transition hover:!bg-red-500/20 active:scale-95"
    >
      Back
    </button>
  </div>
);

export default BannedPage;
